import { ProductFamiliesListQuery } from '../vsSubscriptionApiInjected';

export function transformProductFamilyList(resp: ProductFamiliesListQuery) {
  return resp.productFamilies;
}
